import { useEffect } from 'react';

const DEFAULT_TITLE = "Taxi Porticcio 24h/24 | Chauffeur Privé Rive Sud | Yellow Cab Corsica";
const DEFAULT_DESC = "Service de taxi et chauffeur privé haut de gamme à Porticcio, Rive Sud du Golfe d'Ajaccio. Transferts aéroport Ajaccio, ports, événements. Disponible 24h/24 7j/7. Yellow Cab Corsica — Corse-du-Sud.";
const BASE_URL = 'https://taxiyellowcabcorsica.fr';

const Seo = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) metaDesc.setAttribute('content', description);
    const linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical && canonical) linkCanonical.setAttribute('href', canonical);

    const items = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
    const scripts = items.map((obj) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.setAttribute('data-seo-page', 'true');
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      return s;
    });

    return () => {
      scripts.forEach((s) => s.remove());
      document.title = DEFAULT_TITLE;
      if (metaDesc) metaDesc.setAttribute('content', DEFAULT_DESC);
      if (linkCanonical) linkCanonical.setAttribute('href', BASE_URL);
    };
  }, [title, description, canonical, jsonLd]);

  return null;
};

export default Seo;
